import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTSendAlertRequest } from "../../shared/BTSendAlertRequest";
import { DataService_BusTrackerMap } from "../../shared/data.service";
import { SchoolBusAlertBusTableComponent } from "./school-bus-alert-bus-table/school-bus-alert-bus-table.component";
import * as moment from "moment";

@Component({
	selector: "app-school-bus-alert-modify",
	templateUrl: "./school-bus-alert-modify.component.html",
	styleUrls: ["./school-bus-alert-modify.component.css"],
})
export class SchoolBusAlertModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private mapService: DataService_BusTrackerMap
	) {}

	ngOnInit(): void {
		// console.log(this.dialogConfig.data);

		this.user = this.dialogConfig.data.user;
		this.lstSelectedFromMain = this.dialogConfig.data.lstSelectedBuses;

		this.loadAlertType();
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	@ViewChild(SchoolBusAlertBusTableComponent)
	tableRef: SchoolBusAlertBusTableComponent;

	EditMode: any = false;

	user: any;
	SetEnd: any = false;

	lstSelectedFromMain: any;

	AlertType: any;
	lstAlertType: any = [];

	StartDate: Date = new Date();
	StartTime: Date = new Date();

	EndDate: Date = new Date();
	EndTime: Date = new Date();

	Comments: any = "";

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////////
	loadAlertType() {
		var result = this.mapService.BusAlertTypeSelectList(1);
		result.subscribe(
			(response) => {
				this.lstAlertType = response;

				this.AlertType = this.lstAlertType[0];
			},
			(error) => {}
		);
	}
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY") + " " + moment(this.StartTime).format("HH:mm:00");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY") + " " + moment(this.EndTime).format("HH:mm:00");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Date/Time";
			return;
		}
		if (this.SetEnd == true && String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Date/Time";
			return;
		}

		//
		// Create Request
		//

		let lstIDs: number[] = [];

		for (var z = 0; z < this.tableRef.SelectedBuses.length; z++) {
			var next = this.tableRef.SelectedBuses[z];

			lstIDs = [...lstIDs, next.BusID];
		}

		if (lstIDs.length == 0) {
			this.errorMessage = "Select buses to send an alert to";
			return;
		}

		let parms: BTSendAlertRequest = {
			AlertTypeID: this.AlertType.AlertTypeID,
			PersonID: this.user.personID,
			StartDT: fsDate,
			EndDT: this.SetEnd == true ? feDate : "",
			Comments: this.Comments,
			lstBusIDs: lstIDs,
		};

		//
		// Call SP
		//
		var result = this.mapService.BTSendAlert(parms);
		result.subscribe(
			(response) => {
				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert was sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send the Alert",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////////

	GetColor(Obj) {
		if (Obj == undefined) {
			return "Black";
		} else {
			//High
			if (Obj.Severity == 1) {
				return "Red";
			}
			//Medium
			else if (Obj.Severity == 2) {
				return "Orange";
			}
			//Low
			else if (Obj.Severity == 3) {
				return "Gold";
			} else {
				return "Black";
			}
		}
	}

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	//////////////////////////////////////////////////////////////////////////////////
}
